import { timeFormat } from '@qctsw/utils'
import type { ComplaintDetailResponse } from '~/server/types'
import { complaintDetailApi } from '~/server'
import { ISSUE_TYPE_CODE_ENUM } from '~/shared/constants'

export function useAgain() {
  const { formData } = storeToRefs(usePublishStore())
  // useAgain init
  async function againInitHandle(id: number) {
    await getComplaintDetail(id)
  }

  // get complaint detail
  async function getComplaintDetail(id: number | string) {
    if (!id)
      return

    try {
      const { data } = await complaintDetailApi(id)
      const complaintId = Number(data.complainScoreCode) !== -2 ? undefined : Number(id)
      formatUser(data)
      formatCar(data)
      formatMedia(data)
      formatComplaint(data, complaintId)
      if (Number(data.complainScoreCode) !== -2) {
        useDialog.warning({
          title: '提示',
          content: '再次投诉请求数据失败，当前投诉评分不是非常不满意，已转换成发表普通投诉',
          positiveText: '确定',
          showIcon: false,
        })
        formData.value.isGetDefaultDriving = true
        formData.value.refComplainId = undefined
      }
      else {
        formData.value.isGetDefaultDriving = true
        formData.value.refComplainId = complaintId
      }
    }
    catch (err) {
      recordError(err)
      useDialog.error({
        title: '获取数据失败，请刷新后重试',
        content: getErrorMsg(err),
        positiveText: '确定',
        showIcon: false,
      })
    }
  }

  function formatUser(data: ComplaintDetailResponse) {
    formData.value.userName = data.carUserName
    formData.value.sex = data.userSex
    formData.value.phone = data.userPhone
    formData.value.email = data.userEmail
  }
  function formatCar(data: ComplaintDetailResponse) {
    formData.value.carBrandId = Number(data.carBrandId)
    formData.value.carSeriesId = Number(data.carSeriesId)
    formData.value.carModelId = data.carModelId ? Number(data.carModelId) : undefined
    formData.value.carVin = data.baseInfo.carVin
    formData.value.isWillingToLive = data.isWillingToLive
    formData.value.complainMoney = data.baseInfo.complainMoney
    formData.value.carEngineNumber = data.baseInfo.carVin
    formData.value.carRegionPlate = data.baseInfo.carRegionPlate
    formData.value.carNumberPlate = data.baseInfo.carNumberPlate
    formData.value.carShoppingTime = timeFormat(data.baseInfo.shoppingTime, 'YYYY-MM-DD') ?? undefined
    formData.value.firstFaultTime = timeFormat(data.baseInfo.firstFaultTime, 'YYYY-MM-DD') ?? undefined
    formData.value.carInsuranceCode = data.insuranceCode
    formData.value.carTravelKm = data.baseInfo.travelKm
    formData.value.carDealerId = data.carDealerId
    formData.value.carDealerLinkman = data.baseInfo.dealerLinkman
    formData.value.carDealerPhone = data.baseInfo.dealerPhone ?? undefined
    formData.value.carDealerName = data.dealerName
    formData.value.carDealerAreaIds = [String(data.portalUserProvinceId), String(data.portalUserCityId)]
  }
  function formatComplaint(data: ComplaintDetailResponse, id: number | undefined) {
    let againHtml = ''
    if (id) {
      const origin = window.location.origin
      let resultHtml = ''
      data?.resultLs?.forEach((v: any) => {
        resultHtml += `<p><span ><strong>企业处理${Number(v.disposeTypeCode) === 1 ? '最终' : '临时'}结果:</strong></span></p><p>${v.companyResult}</p>`
      })
      againHtml = `<p><span><strong>上次投诉标题：</strong></span><a href="${origin}/complaint/detail/${id}" target="_blank"><span ><strong>${data.title!}</strong></span></a></p>
      ${data?.baseInfo?.content}
      ${resultHtml}
      `
    }

    formData.value.title = data.title
    formData.value.refComplainContent = againHtml
    formData.value.quality = data.issueLs.filter(v => v.issueTypeCode === ISSUE_TYPE_CODE_ENUM.quality)
      .map(v => v.carPartsId
        ? `${v.issueId}-${v.childIssueId}-${v.carPartsId}-${v.carPartsName}`
        : `${v.issueId}-${v.childIssueId}`)
    formData.value.sale = data.issueLs.filter(v => v.issueTypeCode === ISSUE_TYPE_CODE_ENUM.sale).map(v => v.carPartsId
      ? `${v.issueId}-${v.childIssueId}-${v.carPartsId}-${v.carPartsName}`
      : `${v.issueId}-${v.childIssueId}`)
    formData.value.afterSale = data.issueLs.filter(v => v.issueTypeCode === ISSUE_TYPE_CODE_ENUM.afterSale).map(v => v.carPartsId
      ? `${v.issueId}-${v.childIssueId}-${v.carPartsId}-${v.carPartsName}`
      : `${v.issueId}-${v.childIssueId}`)
    formData.value.appeal = data.issueLs.filter(v => v.issueTypeCode === ISSUE_TYPE_CODE_ENUM.appeal).map(v => Number(v.issueId))
  }
  function formatMedia(data: ComplaintDetailResponse) {
    formData.value.audios = data.audioLs.map(v => v.audioUrl.trim()).filter(v => v)
    formData.value.videos = data.videoLs.map(v => v.videoUrl.trim()).filter(v => v)
    formData.value.pictures = data.imgLs.map(v => v.imgUrl.trim()).filter(v => v)
  }

  return {
    againInitHandle,
    getComplaintDetail,
  }
}
